import React from 'react'
import { useParams } from 'react-router-dom'
import ErrorMessage from '../Components/Common/ErrorMessage';
import LoadingSnipper from '../Components/Common/LoadingSnipper';
import useQuizOnce from '../Components/Hooks/useQuizOnce';
import QuizGame from '../Components/Quizzes/Game/QuizGame';
import useScores from '../Components/Hooks/useScores';
import LearningLayout from '../Components/LearningPlatform/LearningLayout';
// import useScores from '../Hooks/useScores';
function PlayQuizPage({ userId }) {
    const { id } = useParams();

    const quiz = useQuizOnce(id)


    //might need Id as parameter//


    let content;
    if (quiz.status === "loading") {
        content = <LoadingSnipper />
    } else if (quiz.status === "error") {
        content = <ErrorMessage />
    } else if (quiz.exists === "error") {
        content = <ErrorMessage> No quiz found</ErrorMessage>
    } else {
        content = <QuizGame quizData={quiz.data} quizId={id} userId={userId} />
    }

    return (
        <LearningLayout>
            <div className='flex-1 overflow-auto flex flex-col'>
                {content}
            </div>
        </LearningLayout>
    )
}

export default PlayQuizPage